module.exports = __webpack_public_path__ + "static/media/team-health-pool-cartao-visita-768x591.fedcb632.jpg";